import React, { Component } from 'react';
import { Droppable } from '@hello-pangea/dnd';
import JobTile from './JobTile';
import { Box, Typography } from '@mui/material';
import './ProgressTile.css';
import { withTheme } from '../../containers/higherOrderComponents/withTheme';

// Function to dynamically set styles based on drag state and theme
const getListStyle = (isDraggingOver, themeMode) => ({
  background: themeMode === 'dark' 
    ? (isDraggingOver ? '#1F3A60' : '#0A1929') // Dark atom-like blue colors
    : (isDraggingOver ? '#1670bd' : '#e3edf6'),  // Light mode blues
  width: '270px',
  minHeight: '300px',
  maxHeight: '70vh',
  boxShadow: themeMode === 'dark' ? '0px 0px 5px rgba(97, 218, 251, 0.2)' : '0px 0px 1px #fff',
  padding: '15px 10px',
  borderRadius: '10px',
  overflow: 'auto',
  color: themeMode === 'dark' ? 'rgba(255, 255, 255, 0.87)' : 'inherit',
  border: themeMode === 'dark' ? '1px solid rgba(97, 218, 251, 0.1)' : 'none',
});

class ProgressTile extends Component {
  render() {
    const { column, jobsList, selectUpdateJob, deleteJob, themeMode } = this.props;

    return (
      <Box className="mb-5 mx-1 inline">
        <Typography 
          variant="h5" 
          align="center" 
          className="text-uppercase montserrat"
          sx={{ 
            color: themeMode === 'dark' ? 'rgba(255, 255, 255, 0.87)' : '#1976d2',
            fontWeight: 'bold'
          }}
        >
          {column.title}
        </Typography>
        <Droppable droppableId={column.id}>
          {(provided, snapshot) => (
            <Box
              ref={provided.innerRef}
              {...provided.droppableProps}
              sx={getListStyle(snapshot.isDraggingOver, themeMode)}
            >
              {jobsList.map((job, index) => (
                <JobTile
                  key={job.id}
                  job={job}
                  idx={index}
                  selectUpdateJob={selectUpdateJob}
                  deleteJobThunk={() => deleteJob(job.id, column.id)}
                />
              ))}
              {provided.placeholder}
            </Box>
          )}
        </Droppable>
      </Box>
    );
  }
}

export default withTheme(ProgressTile);
